import { WizMaxHeightDirective } from './wiz-max-height.directive';
import { WizMinHeightDirective } from './wiz-min-height.directive';
import { WizMaxWidthDirective } from './wiz-max-width.directive';
import { WizMinWidthDirective } from './wiz-min-width.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WizStyleClassDirective } from './wiz-style-class.directive';
import { WizHeightDirective } from './wiz-height.directive';
import { WizWidthDirective } from './wiz-width.directive';
import { WizStyleDirective } from './wiz-style.directive';
import { WizPaddingDirective } from './wiz-padding.directive';

@NgModule({
  declarations: [
    WizStyleClassDirective,
    WizStyleDirective,
    WizHeightDirective,
    WizWidthDirective,
    WizPaddingDirective,
    WizMinWidthDirective,
    WizMaxWidthDirective,
    WizMinHeightDirective,
    WizMaxHeightDirective
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    WizStyleClassDirective,
    WizStyleDirective,
    WizHeightDirective,
    WizWidthDirective,
    WizPaddingDirective,
    WizMinWidthDirective,
    WizMaxWidthDirective,
    WizMinHeightDirective,
    WizMaxHeightDirective
  ],
})
export class WizStylingDirectiveModule { }
